//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const DAY_MAP = {
  Monday: 'Mo',
  Tuesday: 'Di',
  Wednesday: 'Mi',
  Thursday: 'Do',
  Friday: 'Fr',
  Saturday: 'Sa',
  Sunday: 'So'
}

export default {
  props: {
    showEmpty: {
      type: Boolean,
      default: true
    },
    emptyPlaceholder: {
      type: String,
      default: 'Ruhetag'
    },
    days: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    compactOpeningHours () {
      return this.days.reduce((prev, current, index) => {
        // If no times are given, skip this day.
        if (!current.times.length) { return prev }

        // If at least one day was already added ...
        if (prev.length) {
          const previousTimes = this.days[index - 1].times

          // ... check if the times of the current day match
          // those of the times of the previously added day.
          if (JSON.stringify(previousTimes) === JSON.stringify(current.times)) {
            // Add the name of the current day as the
            // second day in the array of day names.
            //
            // Example:
            // 1. We start with `['Monday']`.
            // 2. The opening hours of Tuesday do match those
            //    of Monday and we get `['Monday', 'Tuesday']`.
            // 3. If the Wednesday opening hours also match
            //    those of Tuesday we end up with
            //    `['Monday', 'Wednesday']` and so on.
            prev[prev.length - 1].days = [prev[prev.length - 1].days[0], DAY_MAP[current.name]]

            return prev
          }
        }

        // Add a new row.
        prev.push({
          days: [DAY_MAP[current.name]],
          times: current.times.map(x => x.start && x.end ? `${x.start}-${x.end}` : '').filter(Boolean)
        })

        return prev
      }, [])
    }
  }
}
